import React from "react";
import {Control, Controller} from "react-hook-form";
import {Icon} from "@blueprintjs/core";
import {OptionType} from "../../../../common/types";
import FilterableMultiSelect from "../../../../common/FilterableMultiSelect";
import {CountSelectedText, ETASelectButton} from "../common/ETANotificationConfigs.style";

interface ETAAttributeSelectProps {
  control: Control<any>;
  name: string;
  options: OptionType[];
  onQueryChange: (query: string) => void;
  onLoadMore?: () => void;
  placeholder: string;
  buttonLabel: string;
  labelText: string;
  testIdPrefix: string;
  optionTooltips?: Record<string | number, string | JSX.Element>;
  optionLabels?: Record<string | number, string>;
}

export const ETAAttributeSelect: React.FC<ETAAttributeSelectProps> = ({
  control,
  name,
  options,
  onQueryChange,
  onLoadMore,
  placeholder,
  buttonLabel,
  labelText,
  testIdPrefix,
  optionTooltips,
  optionLabels
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({field: {onChange, value}}) => {
        const typedValue = (value as OptionType[]) || [];
        const hasValue = typedValue.length > 0;

        const onOptionSelect = (option: OptionType) => {
          const existingIndex = typedValue.findIndex((v: OptionType) => v.key === option.key);
          if (existingIndex !== -1) {
            const newValues = typedValue.filter((v: OptionType) => v.key !== option.key);
            onChange(newValues);
          } else {
            const newValues = [...typedValue, option];
            onChange(newValues);
          }
        };

        const onClear = () => {
          onChange([]);
        };

        return (
          <FilterableMultiSelect
            options={options}
            testIdPrefix={testIdPrefix}
            onOptionSelect={onOptionSelect}
            selectedOptions={typedValue}
            onClear={onClear}
            onQueryChange={onQueryChange}
            placeholder={placeholder}
            optionTooltips={optionTooltips}
            optionLabels={optionLabels}
            text={`${labelText}${typedValue.length > 0 ? ` (${typedValue.length})` : ""}`}
            onLoadMore={onLoadMore}
            customButton={
              <ETASelectButton
                icon={hasValue && <CountSelectedText>{typedValue.length}</CountSelectedText>}
                text={buttonLabel}
                hasValue={hasValue}
                endIcon={
                  hasValue ? (
                    <Icon
                      size={16}
                      icon={"chevron-down"}
                      style={{
                        color: "#2563EB"
                      }}
                    />
                  ) : (
                    <Icon
                      size={16}
                      icon={"plus"}
                      style={{
                        color: "#9CA3AF"
                      }}
                    />
                  )
                }
              />
            }
          />
        );
      }}
    />
  );
};
